module.exports = __webpack_public_path__ + "img/india.51246125.jpg";